import { isActivePaymentsLoading } from "state/school_money/selectors";

/**
 * @returns {boolean}
 */
export function isParentalConsentReady(state, studentID) {
  return !isActivePaymentsLoading(state);
}

/**
 * @returns {Immutable.List}
 */
export function getStudentParentConsentIDList(state, studentID) {
  return state.getIn(["school_money", "parentalConsentItems"])
    .filter(item => item.studentID === studentID)
    .keySeq().toList();
}

export function getParentalConsentItemByID(state, itemID) {
  return state.getIn(["school_money", "parentalConsentItems", itemID]);
}

/**
 * @returns {boolean}
 */
export function isParentalConsentSaving(state, itemID) {
  return state.getIn(["school_money", "pendingParentalConsentItems", itemID]) === "saving";
}

/**
 * @returns {boolean}
 */
export function isAnyPendingParentalConsentItemFailed(state) {
  return state.getIn(["school_money", "pendingParentalConsentItems"]).some(status => status === "failed");
}

/**
 * @returns {boolean}
 */
export function isAnyPendingParentalConsentItemSaved(state) {
  return state.getIn(["school_money", "pendingParentalConsentItems"]).some(status => status === "saved");
}

/**
 * @returns {boolean}
 */
export function doesParentalConsentItemExist(state, itemID) {
  return state.getIn(["school_money", "parentalConsentItems"]).has(itemID);
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/parental_consent.js